import { Record, RecordOf } from 'immutable';

// import { RoleEnum, UserStatusEnum } from 'types/user';
import { IAsyncState, StandardAction } from '../types';
import { UserState } from './types';
import UserAction from './user.actions';

const initData: IAsyncState<UserState> = {
  isFetching: false,
  isUpdating: false,
  data: {
    id: '',
    firstName: '',
    lastName: '',
    role: undefined,
    email: '',
    address1: null,
    address2: null,
    paymentAddress: null,
    paymentDetail: null,
    city: null,
    createdAt: '',
    updatedAt: null,
    state: null,
    status: undefined,
    zip: null,
    avatar: null,
    shippingAddress: null,
    docShippingAddress: null,
    ableScanDoc: false,
  },
};

const initialState = Record(initData)(initData);

export default class UserReducer {
  static getReducer(
    state: RecordOf<IAsyncState<UserState>> = initialState,
    action: StandardAction,
  ): RecordOf<IAsyncState<UserState>> {
    switch (action.type) {
      // Fetch User
      case UserAction.TYPES.FETCH_USER.START:
      case UserAction.TYPES.FETCH_USER.SUCCESS:
      case UserAction.TYPES.FETCH_USER.FAILURE:
        return UserReducer.handleFetchUser(state, action);

      // Update User
      case UserAction.TYPES.UPDATE_USER.START:
      case UserAction.TYPES.UPDATE_USER.SUCCESS:
      case UserAction.TYPES.UPDATE_USER.FAILURE:
        return UserReducer.handleUpdateUser(state, action);

      case UserAction.TYPES.CLEAR_USER:
        return UserReducer.clearUser();

      default:
        return state;
    }
  }

  // handle fetch user
  static handleFetchUser = (
    state: RecordOf<IAsyncState<UserState>>,
    action: StandardAction<UserState>,
  ): RecordOf<IAsyncState<UserState>> => {
    const { payload } = action;
    switch (action.type) {
      case UserAction.TYPES.FETCH_USER.START:
        return {
          ...state,
          isFetching: true,
        };

      case UserAction.TYPES.FETCH_USER.SUCCESS:
        return {
          ...state,
          isFetching: false,
          data: {
            ...state.data,
            ...payload,
          },
        };

      case UserAction.TYPES.FETCH_USER.FAILURE:
        return {
          ...state,
          isFetching: false,
        };

      default:
        return state;
    }
  };

  // handle update user
  static handleUpdateUser = (
    state: RecordOf<IAsyncState<UserState>>,
    action: StandardAction<UserState>,
  ): RecordOf<IAsyncState<UserState>> => {
    switch (action.type) {
      case UserAction.TYPES.UPDATE_USER.START:
        return {
          ...state,
          isUpdating: true,
        };

      case UserAction.TYPES.UPDATE_USER.SUCCESS:
        return {
          ...state,
          isUpdating: false,
        };

      case UserAction.TYPES.UPDATE_USER.FAILURE:
        return {
          ...state,
          isUpdating: false,
        };

      default:
        return state;
    }
  };

  static clearUser = (): RecordOf<IAsyncState<UserState>> => initialState;
}
